import { Component, OnInit, ViewChild } from '@angular/core';
import { HospitalService } from '../../_service/hospital.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
declare var $: any;
import * as XLSX from 'xlsx';
import { LabService } from 'src/app/_service/lab.service';

@Component({
  selector: 'app-lab-list',
  templateUrl: './lab-list.component.html',
  styleUrls: ['./lab-list.component.css']
})
export class LabListComponent implements OnInit {
  @ViewChild('paginatorBottom', { static: false }) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; labList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; myrole: string;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; cities = []; city = ''; circles = []; circle = '';
  search: string; sc3Url = ''; status = ''; circles_copy = [];
  constructor(private labapi: LabService, private sharedapi: SharedService, public leadapi: LeadsService) { }

  ngOnInit(): void {
    this.getcircle();
    this.sharedapi.getRole()
      .subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.sc3Url = localStorage.getItem('s3url');

  }

  setSearchValue() {
    $("#circleSearch").val('');
    $("#circleSearch").focus();
    this.circles = this.circles_copy;
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    }
  }

  ngAfterViewInit() {
    this.loadLabList(0, this.perpage);
  }


  onStatusChange(event, id, index) {
    let status;
    if (event.checked) {
      status = 1;
    } else {
      status = 0;
    }
    let value = {
      'id': id,
      'status': status
    }
    this.labapi.updateLabStatus(value)
      .subscribe((data: any) => {
        if (data.status) {
          this.sharedapi.presentToast('Status Update Successfully');
          this.labList[index].status = data.data.status;
        }
        else {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });

  }

  async loadLabList(pageIndex, perpage) {
    this.labList = [];
    this.paginator.pageIndex = pageIndex;
    this.paginatorBottom.pageIndex = pageIndex;
    this.pageIndex = pageIndex;
    let qString = 'search=' + this.search + '&circle=' + this.circle + '&status=' + this.status;
    this.loading = true; this.loaded = false;
    this.labapi.getLabList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.labList = data.data;
      } else {
        this.labList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadLabList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadLabList(event.pageIndex, event.pageSize);
  }

  async getcircle() {
    this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getcity() {
    this.leadapi.getcities().subscribe((data: any) => {
      if (data.status) {
        this.cities = data.data;
      } else {
        this.cities = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


}
